import type { AppFlyoutAnchorProps } from "./AppFlyoutAnchor.Props";

export const isAppFlyoutAnchorProps = (props: {
  type: string;
}): props is AppFlyoutAnchorProps => {
  return (props as AppFlyoutAnchorProps).type === "AppFlyoutAnchorProps";
};
